// Shared helpers for multi-project record linking.
// A property-scoped record (violation, DOT/FDNY permit, DOB filing) can belong to many
// projects at once via a `project_ids` array. `project_id` is kept as the primary/original link.

// True when the record is linked to project `pid` (via project_ids array or legacy project_id).
export const inProject = (r, pid) => {
  if (!pid) return true;
  const ids = Array.isArray(r?.project_ids) && r.project_ids.length ? r.project_ids : (r?.project_id ? [r.project_id] : []);
  return ids.includes(pid);
};

// PUT patch that additively links a record to project `pid` without unlinking others.
export const buildProjectLinkPatch = (r, pid) => {
  const existing = Array.isArray(r?.project_ids) && r.project_ids.length ? r.project_ids : (r?.project_id ? [r.project_id] : []);
  const patch = { project_ids: Array.from(new Set([...existing, pid])) };
  if (!r?.project_id) patch.project_id = pid;
  return patch;
};
